module.exports = __webpack_public_path__ + "img/new1.52312187.png";